var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _symbol43, _symbol44, _symbol45, _symbol46, _symbol47, _symbol48, _symbol49, _symbol50, _symbol51, _symbol52, _symbol53, _symbol54, _symbol55, _symbol56, _symbol57, _symbol58, _symbol59, _symbol60, _symbol61, _symbol62, _symbol63, _symbol64, _symbol65, _symbol66, _symbol67, _symbol68, _symbol69, _symbol70, _symbol71, _symbol72, _symbol73, _symbol74, _symbol75, _symbol76, _symbol77, _symbol78, _symbol79, _symbol80, _symbol81, _symbol82, _symbol83, _symbol84, _symbol85, _symbol86, _symbol87, _symbol88, _symbol89, _symbol90, _symbol91, _symbol92, _symbol93, _symbol94, _symbol95, _symbol96, _symbol97, _symbol98, _symbol99, _symbol100, _symbol101, _symbol102, _symbol103, _symbol104, _symbol105, _symbol106, _symbol107, _symbol108, _symbol109, _symbol110, _symbol111;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpritesymbol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "activity",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.988 3l-3.681 9.816H0v2h4.692l2.319-6.183 5.056 13.144 3.117-9.354 1.197 2.393H24v-2h-6.382L14.814 7.21l-2.882 8.646z",
    fillRule: "evenodd"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "arrow-down",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.502 9L7 10.386 12 15l5-4.614L15.498 9 12 12.228z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "arrow-left",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 8.502L13.614 7 9 12l4.614 5L15 15.498 11.772 12z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "arrow-right",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 15.498L10.386 17 15 12l-4.614-5L9 8.502 12.228 12z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "arrow-up",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.498 15L17 13.614 12 9l-5 4.614L8.502 15 12 11.772z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "back",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.414 11.707H7.828l2.293-2.293L8.707 8 4 12.707l4.707 4.707L10.121 16l-2.293-2.293h12.586z",
    fillRule: "evenodd"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "before",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.414 8.707H6.828l2.293-2.293L7.707 5 3 9.707l4.707 4.707L9.121 13l-2.293-2.293h4.586c2.205 0 4 1.794 4 4v5h2v-5c0-3.309-2.691-6-6-6z",
    fillRule: "evenodd"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "browser-switch",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 8h-2v2h2l-.001 2H20v2h1.999l-.002 6H8v-2H6v2c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V10c0-1.103-.897-2-2-2M2 14V8h13.999l-.002 6H2zm0-8h2V4H2v2zm4 0h2V4H6v2zm9.999 0H10V4h6l-.001 2zM18 14V4c0-1.103-.897-2-2-2H2C.897 2 0 2.897 0 4v10c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2z",
    fillRule: "evenodd"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "building",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 1.999a1 1 0 011 1v18a1 1 0 01-1 1h-7a1 1 0 01-1-1v-18c0-.551.448-1 1-1h7zm-1 18v-16h-5v16h1v-2h3v2h1zm-10-16a1 1 0 011 1v16a1 1 0 01-1 1H3a1 1 0 01-1-1v-16c0-.551.448-1 1-1h3v-2h2v2h2zm-1 16v-14H4v14h1v-2h3v2h1zm7-14h3v2h-3v-2zm-11 2h3v2H5v-2zm0 4h3v2H5v-2zm11-2h3v2h-3v-2zm0 4h3v2h-3v-2z"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "calendar",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 5c1.103 0 2 .898 2 2v13c0 1.102-.897 2-2 2H4c-1.103 0-2-.898-2-2V7c0-1.102.897-2 2-2h2v2h1V2h2v3h7v2h1V2h2v3h1zm-.003 15l.002-11H4v11h15.997zM6 15v-4h4v4H6zm5 0v-4h4v4h-4z",
    fillRule: "evenodd"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "calendar-add",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.125 16.333v2.875H23v1.917h-2.875V24h-1.917v-2.875h-2.875v-1.917h2.875v-2.875h1.917zM6.708 1v2.875h6.709v1.917h.958V1h1.917v2.875h.958a1.92 1.92 0 011.917 1.917v8.625h-1.919l.001-5.75H1.917v9.583h11.5v1.917h-11.5A1.919 1.919 0 010 18.25V5.792a1.92 1.92 0 011.917-1.917h1.916v1.917h.959V1h1.916z",
    fillRule: "evenodd"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "calendar-check",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.628 17.003L23 18.393 17.463 24l-3.596-3.642 1.372-1.39 2.224 2.253 4.165-4.218zM6.791 1v2.948h6.791v1.965h.97V1h1.941v2.948h.97c1.07 0 1.94.882 1.94 1.965v9.826h-1.942l.001-6.878H1.94v9.825h9.702v1.965H1.94C.87 20.651 0 19.77 0 18.686V5.913C0 4.83.87 3.948 1.94 3.948h1.94v1.965h.97V1h1.941z",
    fillRule: "evenodd"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "calendar-close",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.628 16.807L23 18.18l-2.225 2.225L23 22.628 21.628 24l-2.224-2.225L17.179 24l-1.372-1.372 2.225-2.224-2.225-2.225 1.372-1.372 2.225 2.225 2.224-2.225zM6.791 1v2.91h6.791v1.94h.97V1h1.941v2.91h.97c1.07 0 1.94.872 1.94 1.94v8.732h-1.942l.001-5.82H1.94v9.701h11.642v1.94H1.94c-1.07 0-1.94-.87-1.94-1.94V5.851c0-1.07.87-1.94 1.94-1.94h1.94v1.94h.97V1h1.941z",
    fillRule: "evenodd"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "calendar-closed",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 19H3V9h15.999v2.003L21 11.002V6c0-1.102-.897-2-2-2h-1V1h-2v5h-1V4H8V1H6v5H5V4H3c-1.103 0-2 .898-2 2v13c0 1.102.897 2 2 2h8v-2zm7-7.006c3.309 0 6 2.691 6 6 0 3.31-2.691 6-6 6s-6-2.69-6-6c0-3.309 2.691-6 6-6zm0 10c2.206 0 4-1.794 4-4 0-.74-.215-1.424-.567-2.019l-5.452 5.452a3.947 3.947 0 002.019.567zm0-8c-2.206 0-4 1.795-4 4 0 .74.215 1.424.567 2.02l5.452-5.453A3.947 3.947 0 0018 13.994z",
    fillRule: "evenodd"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "calendar-edit",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.488 11.822a.958.958 0 011.355 0l2.876 2.876a.958.958 0 010 1.355l-6.708 6.708a.973.973 0 01-.445.252l-3.834.958a.96.96 0 01-1.162-1.162l.958-3.833a.973.973 0 01.252-.446zm-2.197 4.908l-2.967 2.968-.508 2.026 2.026-.507 2.968-2.968-1.519-1.519zM6.708 1v2.875h6.708V5.79h.958V1h1.917v2.875h.958a1.92 1.92 0 011.917 1.916v3.834h-1.917v-.959H1.917v9.583h6.708v1.917H1.917A1.919 1.919 0 010 18.249V5.791a1.92 1.92 0 011.917-1.916h1.916V5.79h.958V1h1.917zm12.458 12.855l-1.52 1.52 1.52 1.52 1.52-1.52-1.52-1.52z",
    fillRule: "evenodd"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "calendar-question",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.167 22.083a.958.958 0 110 1.917.958.958 0 010-1.917zm0-9.583A3.838 3.838 0 0123 16.333a3.842 3.842 0 01-2.875 3.713v1.079h-1.917V18.25h.959c1.058 0 1.916-.86 1.916-1.917a1.919 1.919 0 00-1.916-1.916c-1.058 0-1.917.86-1.917 1.916h-1.917a3.838 3.838 0 013.834-3.833zM6.708 1v2.875h6.709v1.917h.958V1h1.917v2.875h.958c1.058 0 1.917.86 1.917 1.917v4.791h-1.919l.001-1.916H1.917v9.583h11.5v1.917h-11.5A1.919 1.919 0 010 18.25V5.792a1.92 1.92 0 011.917-1.917h1.916v1.917h.959V1h1.916z",
    fillRule: "evenodd"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "calendar-refresh",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 12.5c3.171 0 5.75 2.58 5.75 5.75A5.756 5.756 0 0117.25 24a5.71 5.71 0 01-4.066-1.684L11.5 24v-4.792h4.792l-1.753 1.752.016.017a3.794 3.794 0 002.695 1.106 3.837 3.837 0 003.833-3.833 3.837 3.837 0 00-3.833-3.833 3.837 3.837 0 00-3.833 3.833H11.5a5.756 5.756 0 015.75-5.75zM6.708 1v2.875h6.709v1.917h.958V1h1.917v2.875h.958a1.92 1.92 0 011.917 1.917v4.791h-1.918V8.667H1.917v9.583h7.666v1.917H1.917A1.919 1.919 0 010 18.25V5.792a1.92 1.92 0 011.917-1.917h1.916v1.917h.959V1h1.916z",
    fillRule: "evenodd"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "camera",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 7.999c2.757 0 5 2.242 5 5s-2.243 5-5 5-5-2.242-5-5c0-2.757 2.243-5 5-5zm0 8c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3 1.346 3 3 3zm8-10c1.103 0 2 .897 2 2v11c0 1.103-.897 2-2 2H4c-1.103 0-2-.897-2-2v-11c0-1.103.897-2 2-2h3.465L8.871 3.89a1.996 1.996 0 011.664-.891h2.93c.67 0 1.292.333 1.664.891l1.406 2.109H20zm-16 13h16.001l-.001-11h-4.535l-2-3h-2.93l-2 3H4v11z"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "cart",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.087 20l.833-10H7v3h2v-3h6v3h2v-3h1.08l.833 10H5.087zM9 7c0-1.654 1.346-3 3-3s3 1.346 3 3v1H9V7zm10.997 1.917A1 1 0 0019 8h-2V7c0-2.757-2.243-5-5-5S7 4.243 7 7v1H5a1 1 0 00-.997.917l-1 12A1 1 0 004 22h16a.998.998 0 00.997-1.083l-1-12z",
    fillRule: "evenodd"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "clock",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22c-4.962 0-9-4.037-9-9s4.038-9 9-9 9 4.037 9 9-4.038 9-9 9zm0-16c-3.86 0-7 3.14-7 7s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm2.293 10.707l-3-3A1 1 0 0111 13V8h2v4.586l2.707 2.707-1.414 1.414zM21.14 8.1l-4.239-4.238A2.983 2.983 0 0119 3a3 3 0 012.141 5.099zm-18.281 0A3 3 0 015 3c.817 0 1.557.329 2.098.861L2.859 8.099z",
    fillRule: "evenodd"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "close",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.39 5.33L19.06 4l-6.863 6.864L5.332 4 4 5.33l6.864 6.865L4 19.059l1.332 1.33 6.864-6.863 6.863 6.864 1.332-1.331-6.864-6.864z",
    fillRule: "evenodd"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "comment",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 3.001H5c-1.104 0-2 .898-2 2v14c0 1.103.896 2 2 2h7c.819 0 1.835-.42 2.414-1L20 14.416c.58-.58 1-1.595 1-2.414v-7a2.002 2.002 0 00-2-2.001zm-14 16v-14h14v7h-4c-1.654 0-3 1.346-3 3v4H5zm9-1.414v-2.586c0-.552.449-1 1-1h2.586L14 17.587z",
    fillRule: "evenodd"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "content-view",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 13c1.104 0 2 .897 2 2v5c0 1.103-.896 2-2 2H4c-1.104 0-2-.897-2-2v-5c0-1.103.896-2 2-2h5zm0 2H4v5h4.997L9 15zm13 3v2H12v-2h10zm0-3v2H12v-2h10zM9 2c1.104 0 2 .897 2 2v5c0 1.103-.896 2-2 2H4c-1.104 0-2-.897-2-2V4c0-1.103.896-2 2-2h5zm0 2H4v5h4.997L9 4zm13 3v2H12V7h10zm0-3v2H12V4h10z",
    fillRule: "evenodd"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "copy",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.924 2h-6.59a1.78 1.78 0 00-1.778 1.778v12.444c0 .98.797 1.778 1.777 1.778h8.89A1.78 1.78 0 0020 16.222V6.076L15.924 2zm2.3 14.222h-8.89V3.778h5.333v3.555h3.555l.001 8.89zM5.777 5.556v14.222h10.666v1.778H5.778A1.78 1.78 0 014 19.778V5.556h1.778z",
    fillRule: "evenodd"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "credit-card",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 4c1.104 0 2 .898 2 2v12c0 1.103-.896 2-2 2H4c-1.104 0-2-.897-2-2V6c0-1.102.896-2 2-2h16zm0 2H4v3h15.999L20 6zM4 18h15.997l.002-7H4v7zm11-6h4v2h-4v-2zM5 12h7v2H5v-2zm0 3h5v2H5v-2z"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "danger",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2zm0 18c4.411 0 8-3.589 8-8s-3.589-8-8-8-8 3.589-8 8 3.589 8 8 8zm2.293-11.707l1.414 1.414L13.414 12l2.293 2.293-1.414 1.414L12 13.414l-2.293 2.293-1.414-1.414L10.586 12 8.293 9.707l1.414-1.414L12 10.586l2.293-2.293z",
    fillRule: "evenodd"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "dashboard",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 2c1.103 0 2 .897 2 2v16c0 1.103-.897 2-2 2H3c-1.103 0-2-.897-2-2V4c0-1.103.897-2 2-2h18zM3 20h17.997l.002-12H3v12zM6 6V4H3v2h3zm2-2v2h3V4H8zm13 2V4h-8v2h8zM9 18v-2h10v2H9zm-3-2a1 1 0 110 2 1 1 0 010-2zm3-1v-2h10v2H9zm-3-2a1 1 0 110 2 1 1 0 010-2zm3-1v-2h10v2H9zm-3-2a1 1 0 110 2 1 1 0 010-2z",
    fillRule: "evenodd"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "delete",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 20c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V8H5v12zm2-10h10l.001 10H7V10zm8-5h6v2H3V5h6V3h6v2zm-6 7v6h2v-6H9zm4 0v6h2v-6h-2z",
    fillRule: "evenodd"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "devices",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2.001c1.103 0 2 .896 2 2v4h-2v-1H4v10h8v2H4v1h8v2H4c-1.103 0-2-.896-2-2v-16c0-1.104.897-2 2-2zm4 8c1.103 0 2 .896 2 2v8c0 1.104-.897 2-2 2h-4c-1.103 0-2-.896-2-2v-8c0-1.104.897-2 2-2zm.001 9H16v1h4.001v-1zm-.001-7h-4v5h4.001l-.001-5zm-4-8H4v1h12v-1z",
    fillRule: "evenodd"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "dialog",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 4v12h4v2l2.667-2H20V4H4zm2 18v-4H4c-1.103 0-2-.898-2-2V4c0-1.103.897-2 2-2h16c1.103 0 2 .897 2 2v12c0 1.102-.897 2-2 2h-8.667L6 22z",
    fillRule: "evenodd"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "dialog-chat",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.625 9.273c.758 0 1.375.612 1.375 1.363V17c0 .752-.617 1.364-1.375 1.364H20.25V22l-4.89-3.636h-2.902A1.371 1.371 0 0111.083 17v-6.364c0-.751.617-1.363 1.375-1.363h9.167zm-.458 1.818h-8.25v5.454h3.056l2.444 1.819v-1.819h2.75v-5.454zM14.292 2c.758 0 1.375.612 1.375 1.364v4.089h-1.834V3.818h-11v9.091h2.75v1.818l2.444-1.818H9.25v1.818h-.61l-4.89 3.637v-3.637H2.375A1.371 1.371 0 011 13.364v-10C1 2.612 1.617 2 2.375 2h11.917z",
    fillRule: "evenodd"
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "document",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.414 2L20 6.586V20c0 1.102-.897 2-2 2H6c-1.103 0-2-.898-2-2V4c0-1.102.897-2 2-2h9.414zm2.587 18L18 8h-4V4H6v16h12.001zM14 11v2H8v-2h6zm-6 6v-2h8v2H8z",
    fillRule: "evenodd"
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "document-add",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.414 2L18 6.586V13h-1.999L16 8h-4V4H4v16h9v2H4c-1.103 0-2-.898-2-2V4c0-1.102.897-2 2-2h9.414zm5.717 12.5v2.779h2.779v1.852h-2.779v2.779H17.28v-2.779H14.5V17.28h2.779V14.5h1.852zM12 15v2H6v-2h6zm2-4v2H6v-2h8z",
    id: "bga"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bga",
    fillRule: "evenodd"
  }))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "document-check",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.807 15.917L22 17.125 17.185 22l-3.127-3.166 1.193-1.208 1.934 1.958 3.622-3.667zM13.414 2L18 6.586V13h-1.999L16 8h-4V4H4v16h9v2H4c-1.103 0-2-.898-2-2V4c0-1.102.897-2 2-2h9.414zM12 15v2H6v-2h6zm2-4v2H6v-2h8z",
    id: "bha"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bha",
    fillRule: "evenodd"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "document-configuration",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 4v16h6.983v2H4c-1.103 0-2-.898-2-2V4c0-1.102.897-2 2-2h9.414L18 6.586V11h-1.999L16 8h-4V4H4zm2 9v-2h8v2H6zm0 4v-2h5v2H6zm16 1.833h-.918a4.144 4.144 0 01-.61 1.46l.653.652-1.177 1.178-.653-.652c-.438.29-.93.502-1.461.61V23h-1.666v-.918a4.118 4.118 0 01-1.461-.61l-.652.654-1.18-1.178.654-.654a4.125 4.125 0 01-.61-1.461H12v-1.667h.918c.108-.53.32-1.024.61-1.46l-.652-.653 1.178-1.178.652.652c.438-.289.93-.501 1.46-.609V13h1.667v.918c.53.108 1.023.32 1.46.61l.653-.655 1.178 1.178-.653.654c.29.437.503.93.61 1.461H22v1.667zm-5 .833a1.667 1.667 0 10-.002-3.334 1.667 1.667 0 00.001 3.334z",
    fillRule: "evenodd"
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "document-delete",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 4v16h9v2H4c-1.103 0-2-.898-2-2V4c0-1.102.897-2 2-2h9.414L18 6.586V13h-1.999L16 8h-4V4H4zm2 9v-2h8v2H6zm0 4v-2h6v2H6zm15.707-1.293L19.414 18l2.293 2.294-1.414 1.412L18 19.415l-2.293 2.291-1.414-1.412L16.586 18l-2.293-2.293 1.414-1.414L18 16.587l2.293-2.292 1.414 1.412z",
    fillRule: "evenodd"
  }))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "document-image",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.414 1.001L21 5.587v15.414c0 1.103-.897 2-2 2H5c-1.103 0-2-.897-2-2v-18c0-1.103.897-2 2-2h11.414zm-1.414 2H5v18h14.001l-.001-14h-4v-4zm-1 9.001l3 6H7l3-4 2 2 2-4zm-4-3a2 2 0 110 4 2 2 0 010-4z",
    fillRule: "evenodd"
  }))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "document-pdf",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 20v1h14v-1h2v1c0 1.103-.897 2-2 2H5c-1.103 0-2-.897-2-2v-1h2zm6-10c2.206 0 4 1.794 4 4s-1.794 4-4 4H9v-8zm11 0v2h-4v1h3v2h-3v3h-2v-6c0-1.102.897-2 2-2h4zM5 10c1.654 0 3 1.346 3 3s-1.346 3-3 3H4v2H2v-8zm6 2v4c1.103 0 2-.897 2-2 0-1.102-.897-2-2-2zm-6 0H4v2h1a1.001 1.001 0 000-2zM16.414 1L21 5.586V8h-2V7h-4V3H5v5H3V3c0-1.102.897-2 2-2h11.414z",
    fillRule: "evenodd"
  }))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "document-view",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.034 11.336a4.703 4.703 0 014.698 4.698 4.66 4.66 0 01-.783 2.586L23 21.671 21.671 23l-3.05-3.05a4.664 4.664 0 01-2.587.782 4.703 4.703 0 01-4.698-4.698 4.703 4.703 0 014.698-4.698zM13.604 1l4.309 4.309v4.147h-1.88V6.638h-3.758V2.879H2.88v16.913h7.517v1.88H2.88A1.881 1.881 0 011 19.791V2.88C1 1.844 1.843 1 2.88 1h10.724zm2.43 12.215a2.822 2.822 0 00-2.82 2.819 2.822 2.822 0 002.82 2.819 2.822 2.822 0 002.819-2.82 2.822 2.822 0 00-2.82-2.818zm-6.578 0v1.88H4.758v-1.88h4.698zm2.82-3.759v1.88H4.757v-1.88h7.517z",
    fillRule: "evenodd"
  }))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "download",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 3c1.103 0 2 .897 2 2v8c0 1.103-.897 2-2 2h-1v-2h1V5H7v8h1v2H7c-1.103 0-2-.897-2-2V5c0-1.103.897-2 2-2h10zm-6 6h2v9.586l2.293-2.292 1.414 1.414L12 22.415l-4.707-4.707 1.414-1.414L11 18.586V9z",
    fillRule: "evenodd"
  }))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "edit",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.821 3.179A3.997 3.997 0 0017.974 2a3.997 3.997 0 00-2.846 1.179L3.72 14.587s0 .003-.003.004a1.274 1.274 0 00-.26.461L2.03 20.756a.997.997 0 00.263.949l.001.001.001.001a1 1 0 00.95.264l5.703-1.427a1.266 1.266 0 00.465-.264l11.41-11.407A3.996 3.996 0 0022 6.026a4.002 4.002 0 00-1.178-2.847zm-6.41 3.549l2.863 2.863-8.568 8.568-2.863-2.863 8.568-8.568zM4.375 19.626l.595-2.374 1.78 1.781-2.375.593zM19.41 4.594c.764.765.764 2.099 0 2.864l-.719.72-2.866-2.865.721-.719c.765-.764 2.1-.765 2.864 0z",
    fillRule: "evenodd"
  }))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "email",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4 17V9.179l7.47 4.669a1.002 1.002 0 001.06 0L20 9.179 20.001 17H4zm14.113-9L12 11.821 5.887 8h12.226zM20 6H4c-1.103 0-2 .898-2 2v9c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.102-.897-2-2-2z",
    id: "bpa"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bpa",
    fillRule: "evenodd"
  }))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "email-open",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 22H4c-1.103 0-2-.897-2-2v-9a1 1 0 011.64-.768L9.362 15h5.276l5.722-4.768A1.001 1.001 0 0122 11v9c0 1.103-.897 2-2 2zM4 13.135V20h16.001L20 13.135l-4.36 3.634c-.18.149-.406.23-.64.23H9c-.234 0-.46-.081-.64-.23L4 13.135zM20 9h-2V4H6v5H4V2h16v7z",
    fillRule: "evenodd"
  }))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "expand",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 5.999v2H4v12h12v-6h2v6a2 2 0 01-2 2H4a2 2 0 01-2-2v-12a2 2 0 012-2h6zm11-3v7h-2V6.413L7.707 17.706l-1.414-1.414L17.586 4.999H14v-2h7z",
    fillRule: "evenodd"
  }))), _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "external-link",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 5.586L21.414 10 17 14.414 15.586 13l2-2H12c-1.103 0-2 .898-2 2v1H8v-1c0-2.206 1.794-4 4-4h5.586l-2-2L17 5.586zM13 18v-3h2v5H2V4h13v2H4v12h9z",
    fillRule: "evenodd"
  }))), _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "facebook",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.299 21l-.026-8.182H6V9.545h3.273V7.5c0-3.037 1.88-4.5 4.589-4.5 1.298 0 2.413.097 2.738.14v3.173l-1.879.001c-1.473 0-1.758.7-1.758 1.727v1.504h4.287l-1.636 3.273h-2.651V21H9.299z",
    fillRule: "evenodd"
  }))), _symbol47 || (_symbol47 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "feed",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 22c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm10-1h-2c0-5.515-4.486-10-10-10V9c6.617 0 12 5.383 12 12zm6 0h-2c0-8.822-7.178-16-16-16V3c9.925 0 18 8.075 18 18z",
    fillRule: "evenodd"
  }))), _symbol48 || (_symbol48 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "filter",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.293 12.293A1.002 1.002 0 0013 13v3.586l-2 2V13a.997.997 0 00-.293-.707L6 7.586V4h12v3.586l-4.707 4.707zM18 2H6c-1.103 0-2 .898-2 2v4c0 .256.098.512.293.707L9 13.414V21a1.002 1.002 0 001.707.707l4-4A.997.997 0 0015 17v-3.586l4.707-4.707A.997.997 0 0020 8V4c0-1.102-.897-2-2-2z",
    fillRule: "evenodd"
  }))), _symbol49 || (_symbol49 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "flip",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7 17.3L10.4 16H16v-2h-5.6l1.3-1.3-1.4-1.4L6.6 15l3.7 3.7 1.4-1.4zm.6-6l1.4 1.4L17.4 9l-3.7-3.7-1.4 1.4L13.6 8H8v2h5.6l-1.3 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16z"
  }))), _symbol50 || (_symbol50 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "forward",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 10.707h12.586l-2.293-2.293L15.707 7l4.707 4.707-4.707 4.707L14.293 15l2.293-2.293H4z",
    fillRule: "evenodd"
  }))), _symbol51 || (_symbol51 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "globe",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM8 5.083a7.933 7.933 0 013-1.013V10h3v3.5l-2.49 1.867L9.721 10H8V5.083zM12 20c-4.411 0-8-3.589-8-8 0-2.021.759-3.864 2-5.274V12h2.279l2.211 6.633L16 14.5V8h-3V4.069c3.94.495 7 3.859 7 7.931 0 4.411-3.589 8-8 8z"
  }))), _symbol52 || (_symbol52 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "graph",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 4c1.104 0 2 .898 2 2v12c0 1.103-.896 2-2 2H4c-1.104 0-2-.897-2-2V6c0-1.102.896-2 2-2h16zm-.003 14L20 6H4v12h15.997zM7 12h2v4H7v-4zm4-2h2v6h-2v-6zm4 1h2v5h-2v-5z"
  }))), _symbol53 || (_symbol53 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "heart",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 6C6.346 6 5 7.346 5 9c0 3.363 4.643 7.206 7 8.806 2.357-1.6 7-5.443 7-8.806 0-1.654-1.346-3-3-3-1.689 0-3 1.613-3 3a1 1 0 01-2 0c0-1.387-1.311-3-3-3m4 14c-.184 0-.368-.051-.53-.152C11.124 19.632 3 14.491 3 9c0-2.757 2.243-5 5-5 1.594 0 3.071.837 4 2.08C12.929 4.837 14.406 4 16 4c2.757 0 5 2.243 5 5 0 5.491-8.124 10.632-8.47 10.848A1.002 1.002 0 0112 20",
    fillRule: "evenodd"
  }))), _symbol54 || (_symbol54 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "heart-filled",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 20c-.184 0-.368-.051-.53-.152C11.124 19.632 3 14.491 3 9c0-2.757 2.243-5 5-5 1.594 0 3.071.837 4 2.08C12.929 4.837 14.406 4 16 4c2.757 0 5 2.243 5 5 0 5.491-8.124 10.632-8.47 10.848A1.002 1.002 0 0112 20z",
    fillRule: "evenodd"
  }))), _symbol55 || (_symbol55 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "home",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 21.999h-2c-1.103 0-2-.896-2-2v-3h-2v3c0 1.104-.897 2-2 2H7c-1.103 0-2-.896-2-2v-6H3a1 1 0 01-.707-1.706l9-9a1 1 0 011.414 0l9 9A.999.999 0 0121 13.999h-2v6c0 1.103-.897 2-2 2zm-7-7h4c.552 0 1 .449 1 1v4h2.001l-.001-7c0-.551.448-1 1-1h.586L12 5.414l-6.586 6.585H6c.552 0 1 .449 1 1v7h2v-4a1 1 0 011-1z",
    fillRule: "evenodd"
  }))), _symbol56 || (_symbol56 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "id-card",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.001 4c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2h-16c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2zm0 2h-16v12h16V6zm-2 8v2h-4v-2h4zm-9-1c1.841 0 3 1.159 3 3h-6c0-1.775 1.078-2.916 2.805-2.996L9.001 13zm9-2v2h-4v-2h4zm-9-3a2 2 0 110 4 2 2 0 010-4z",
    fillRule: "evenodd"
  }))), _symbol57 || (_symbol57 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "image",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.383 12.478l3.289 3.47L14.864 8 21 20H3l4.383-7.522zM7.09 8.779c-1.356 0-2.455-1.07-2.455-2.39S5.736 4 7.091 4c1.356 0 2.454 1.07 2.454 2.39S8.447 8.78 7.091 8.78z",
    fillRule: "evenodd"
  }))), _symbol58 || (_symbol58 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "incoming",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 17.415v2h12v-2h2v2c0 1.102-.896 2-2 2H6c-1.104 0-2-.898-2-2v-2h2zm7-15.414v10.586l3.293-3.293 1.414 1.414L12 16.415l-5.707-5.707 1.414-1.414L11 12.587V2.001h2z",
    fillRule: "evenodd"
  }))), _symbol59 || (_symbol59 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "info",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C6.486 22 2 17.515 2 12 2 6.487 6.486 2 12 2s10 4.486 10 10c0 5.515-4.486 10-10 10zm0-18c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm1 11v-4a1 1 0 00-1-1h-2v2h1v3H9v2h6v-2h-2zm-1-5.75a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z"
  }))), _symbol60 || (_symbol60 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "instagram",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.802c2.67 0 2.987.01 4.04.058 1.14.052 2.195.28 3.008 1.092.812.813 1.04 1.869 1.092 3.007.048 1.054.058 1.371.058 4.041 0 2.67-.01 2.987-.058 4.04-.052 1.14-.28 2.195-1.093 3.008-.812.812-1.868 1.04-3.006 1.092-1.054.048-1.371.058-4.041.058-2.67 0-2.987-.01-4.04-.058-1.14-.052-2.195-.28-3.008-1.093-.812-.812-1.04-1.868-1.092-3.006-.048-1.054-.058-1.371-.058-4.041 0-2.67.01-2.987.058-4.04.052-1.14.28-2.195 1.092-3.008.813-.812 1.869-1.04 3.007-1.092C9.013 3.812 9.33 3.802 12 3.802zM12 2c-2.716 0-3.057.012-4.123.06-1.625.074-3.053.473-4.199 1.618C2.533 4.824 2.134 6.252 2.06 7.877 2.012 8.943 2 9.284 2 12s.012 3.057.06 4.123c.074 1.625.473 3.053 1.618 4.199 1.146 1.146 2.574 1.544 4.199 1.618 1.066.048 1.407.06 4.123.06s3.057-.012 4.123-.06c1.625-.074 3.053-.473 4.199-1.618 1.146-1.146 1.544-2.574 1.618-4.199.048-1.066.06-1.407.06-4.123s-.012-3.057-.06-4.123c-.074-1.625-.473-3.053-1.618-4.199-1.146-1.145-2.574-1.544-4.199-1.618C15.057 2.012 14.716 2 12 2zm0 4.865a5.135 5.135 0 100 10.27 5.135 5.135 0 000-10.27zm0 8.468a3.333 3.333 0 110-6.667 3.333 3.333 0 010 6.667zm5.338-7.471a1.2 1.2 0 100-2.4 1.2 1.2 0 000 2.4z"
  }))), _symbol61 || (_symbol61 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "lightning",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.08 12H11a1 1 0 011 1v5.15L16.92 12H13a1 1 0 01-1-1V5.851l-4.92 6.15zM11 22a1 1 0 01-1-1v-7H5a1 1 0 01-.78-1.625l8-10A.998.998 0 0114 3v7h5a1.002 1.002 0 01.78 1.625l-8 10A.998.998 0 0111 22z",
    fillRule: "evenodd"
  }))), _symbol62 || (_symbol62 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "link",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.484 7.744l.708.707c.566.566.878 1.32.878 2.121 0 .801-.312 1.554-.878 2.12l-8.485 8.485a2.98 2.98 0 01-2.121.879 2.98 2.98 0 01-2.122-.879l-.707-.707 1.414-1.413.707.707a1.027 1.027 0 001.415 0l8.485-8.486a.996.996 0 00.292-.706.99.99 0 00-.292-.707l-.708-.707 1.414-1.414zM9.878 12.691l1.413 1.413-7.07 7.073-1.414-1.413 7.07-7.073zm1.415-9.898c1.132-1.134 3.109-1.134 4.243 0l.706.707-1.413 1.413-.707-.707a.996.996 0 00-.708-.293.99.99 0 00-.707.293l-8.486 8.485a1.002 1.002 0 000 1.415l.707.707-1.414 1.414-.706-.707a3.003 3.003 0 010-4.243zm8.484 0l1.414 1.414-7.07 7.071-1.415-1.414 7.071-7.071z",
    fillRule: "evenodd"
  }))), _symbol63 || (_symbol63 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "linkedin",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.167 2H2.833c-.5 0-.833.333-.833.833v18.334c0 .5.333.833.833.833h18.334c.5 0 .833-.333.833-.833V2.833c0-.5-.333-.833-.833-.833zM7.917 19.083H5V9.5h3v9.583h-.083zm-1.5-10.916c-.917 0-1.75-.75-1.75-1.75 0-.917.75-1.75 1.75-1.75.916 0 1.75.75 1.75 1.75s-.75 1.75-1.75 1.75zm12.666 10.916h-3v-4.666c0-1.084 0-2.5-1.5-2.5-1.583 0-1.75 1.166-1.75 2.416v4.75h-3V9.5h2.834v1.333c.416-.75 1.333-1.5 2.833-1.5 3 0 3.583 2 3.583 4.584v5.166z",
    fillRule: "evenodd"
  }))), _symbol64 || (_symbol64 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "list",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 11h3v2H4v-2zm0 5h3v2H4v-2zM4 6h3v2H4V6zm5 5h11v2H9v-2zm0 5h11v2H9v-2zM9 6h11v2H9V6z",
    fillRule: "evenodd"
  }))), _symbol65 || (_symbol65 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "list-add",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 13v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2zM5 14v2H2v-2h3zm7 0v2H7v-2h5zM5 9v2H2V9h3zm13 0v2H7V9h11zM5 4v2H2V4h3zm13 0v2H7V4h11z",
    fillRule: "evenodd"
  }))), _symbol66 || (_symbol66 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "list-question",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 18a1 1 0 110 2 1 1 0 010-2zm0-10c2.205 0 4 1.794 4 4a4.01 4.01 0 01-3 3.874V17h-2v-3h1c1.104 0 2-.897 2-2 0-1.102-.896-2-2-2s-2 .898-2 2h-2c0-2.206 1.795-4 4-4zM5 14v2H2v-2h3zm7 0v2H7v-2h5zM5 9v2H2V9h3zm7 0v2H7V9h5zM5 4v2H2V4h3zm13 0v2H7V4h11z",
    fillRule: "evenodd"
  }))), _symbol67 || (_symbol67 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "location",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.967 22H5a1.996 1.996 0 01-1.669-.898 1.996 1.996 0 01-.168-1.892l2.142-4.998A1.995 1.995 0 017.143 13h.824v2h-.824L5 20h14.967l-2.143-5h-.857v-2h.857a2 2 0 011.84 1.213l2.141 4.999a1.99 1.99 0 01-.168 1.888c-.373.565-.997.9-1.67.9zm-7.483-3a1 1 0 01-.91-.586C10.891 16.913 7.484 9.309 7.484 7c0-2.757 2.243-5 5-5s5 2.243 5 5c0 2.309-3.406 9.913-4.09 11.414a.998.998 0 01-.91.586zm0-15c-1.654 0-3 1.346-3 3 0 1.183 1.593 5.261 3 8.527 1.408-3.266 3-7.345 3-8.527 0-1.654-1.346-3-3-3zm1.5 3a1.5 1.5 0 11-2.998.001A1.5 1.5 0 0113.984 7z",
    fillRule: "evenodd"
  }))), _symbol68 || (_symbol68 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "lock",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10zm0-18c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm3 6a2.988 2.988 0 01-1.622 2.65L14 17h-4l.622-4.35A2.988 2.988 0 019 10a3.001 3.001 0 016 0z",
    fillRule: "evenodd"
  }))), _symbol69 || (_symbol69 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "logout",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 2c1.103 0 2 .898 2 2v16c0 1.103-.897 2-2 2H7c-1.103 0-2-.897-2-2v-3h2v3h11V4H7v3H5V4c0-1.102.897-2 2-2h11zm-6.293 5.292l4.707 4.699-4.706 4.715-1.416-1.412L12.582 13H4v-2h8.59l-2.297-2.292 1.414-1.416z",
    fillRule: "evenodd"
  }))), _symbol70 || (_symbol70 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "menu",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 11h16v2H4v-2zm0 5h16v2H4v-2zM4 6h16v2H4V6z",
    fillRule: "evenodd"
  }))), _symbol71 || (_symbol71 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "minus",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 11h16v2H4z",
    fillRule: "evenodd"
  }))), _symbol72 || (_symbol72 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "move",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2h6v5.999h-2V5.414l-5.292 5.293-1.414-1.414L18.587 4H16V2zM4 18.586l5.293-5.293 1.414 1.414L5.414 20h2.587v2H2v-6h2v2.586zM2 2h6v2H5.414l5.293 5.293-1.414 1.414L4 5.414v2.585H2V2zm11.293 12.707l1.414-1.414L20 18.586V16h2v6h-6v-2h2.586l-5.293-5.293z",
    fillRule: "evenodd"
  }))), _symbol73 || (_symbol73 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "next",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 8.707h4.586l-2.293-2.293L15.707 5l4.707 4.707-4.707 4.707L14.293 13l2.293-2.293H12c-2.205 0-4 1.794-4 4v5H6v-5c0-3.309 2.691-6 6-6z",
    fillRule: "evenodd"
  }))), _symbol74 || (_symbol74 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "notifications",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.555 19h6.89c-.693 1.19-1.969 2-3.445 2-1.476 0-2.752-.81-3.445-2zM21 18H3v-2.721l.684-.227A3.385 3.385 0 006 11.838V9c0-3.309 2.691-6 6-6s6 2.691 6 6v2.838c0 1.46.931 2.751 2.316 3.214l.684.227V18zM6.035 16h11.931A5.376 5.376 0 0116 11.838V9c0-2.206-1.794-4-4-4S8 6.794 8 9v2.838c0 1.648-.745 3.16-1.965 4.162z",
    fillRule: "evenodd"
  }))), _symbol75 || (_symbol75 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "open-lock",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2c2.757 0 5 2.243 5 5v1h-2V7c0-1.654-1.346-3-3-3S9 5.346 9 7v4h8c1.103 0 2 .896 2 2v7c0 1.103-.897 2-2 2H7c-1.103 0-2-.897-2-2v-7c0-1.104.897-2 2-2V7c0-2.757 2.243-5 5-5zm5 11H7v7h10.002L17 13zm-5 2a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0112 15z",
    fillRule: "evenodd"
  }))), _symbol76 || (_symbol76 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "outgoing",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 17.001v2h12v-2h2v2c0 1.102-.896 2-2 2H6c-1.104 0-2-.898-2-2v-2h2zm6-14.414l5.707 5.707-1.414 1.414L13 6.415v9.586h-2V6.415L7.707 9.708 6.293 8.294 12 2.587z",
    fillRule: "evenodd"
  }))), _symbol77 || (_symbol77 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "overflow",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 14a2 2 0 110-4 2 2 0 010 4zm7 0a2 2 0 110-4 2 2 0 010 4zM5 14a2 2 0 110-4 2 2 0 010 4z"
  }))), _symbol78 || (_symbol78 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "paperclip",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 23c-2.897 0-5-2.313-5-5.5V9c0-3.991 2.794-7 6.5-7S19 5.009 19 9v7h-2V9c0-2.897-1.893-5-4.5-5S8 6.103 8 9v8.5c0 1.743.928 3.5 3 3.5s3-1.757 3-3.5V10c0-.602-.146-2-1.5-2S11 9.398 11 10v7H9v-7c0-2.393 1.407-4 3.5-4S16 7.607 16 10v7.5c0 3.187-2.103 5.5-5 5.5",
    fillRule: "evenodd"
  }))), _symbol79 || (_symbol79 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "phone",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 2c1.103 0 2 .897 2 2v4c0 1.072-.848 1.95-1.908 1.998.437 2.584 2.367 4.52 4.909 4.924A2.003 2.003 0 0115 13h4c1.103 0 2 .897 2 2v4c0 1.103-.897 2-2 2h-5C7.383 21 2 15.617 2 9V4c0-1.103.897-2 2-2h4zm0 2H4v5c0 5.514 4.486 10 10 10h5.001L19 15h-4v1a1 1 0 01-1 1c-4.488 0-7.928-3.433-8-7.984A1 1 0 017 8h1V4zm5 3.5a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0113 7.5zm4 0a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0117 7.5zm4 0a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0121 7.5z",
    fillRule: "evenodd"
  }))), _symbol80 || (_symbol80 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "plus",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 11h-7V4h-2v7H4v2h7v7h2v-7h7z",
    fillRule: "evenodd"
  }))), _symbol81 || (_symbol81 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "preferences",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 9c1.654 0 3-1.346 3-3s-1.346-3-3-3a2.993 2.993 0 00-2.815 2H2v2h14.185A2.993 2.993 0 0019 9zm0-4a1 1 0 110 2 1 1 0 010-2zM9 9c1.302 0 2.401.838 2.815 2H22v2H11.815A2.994 2.994 0 019 15a2.994 2.994 0 01-2.815-2H2v-2h4.185A2.993 2.993 0 019 9zm0 4a1 1 0 100-2 1 1 0 000 2zm10 2c1.654 0 3 1.346 3 3s-1.346 3-3 3a2.994 2.994 0 01-2.815-2H2v-2h14.185A2.993 2.993 0 0119 15zm0 4a1 1 0 100-2 1 1 0 000 2z",
    fillRule: "evenodd"
  }))), _symbol82 || (_symbol82 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "print",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 17h-1v-2H5v2H4v-7c0-.552.449-1 1-1v2h14V9c.551 0 1 .448 1 1v7zM7 21h10v-4H7v4zm15-11v9h-3v4H5v-4H2v-9c0-1.654 1.346-3 3-3h2v2h10V7h2c1.654 0 3 1.346 3 3zM7 4v2H5V2h14v4h-2V4H7zm10 8a1 1 0 100 2 1 1 0 000-2z",
    fillRule: "evenodd"
  }))), _symbol83 || (_symbol83 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "progress",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.152 4.652c0 2.203-3.304 2.203-3.304 0s3.304-2.203 3.304 0zm-.826 16.522c0 1.101-1.652 1.101-1.652 0 0-1.102 1.652-1.102 1.652 0zM9.678 4.996c1.01 1.75-1.614 3.265-2.624 1.515-1.01-1.748 1.614-3.263 2.624-1.515zm7.55 14.731c.46.796-.732 1.484-1.191.688-.46-.794.733-1.483 1.192-.688zM6.033 7.595c1.589.918.212 3.303-1.377 2.385-1.59-.918-.214-3.303 1.377-2.385zm13.9 8.968c.635.367.085 1.32-.55.954-.638-.367-.087-1.321.55-.954zm-14.454-3.65c0 1.652-2.478 1.652-2.478 0s2.478-1.652 2.478 0zm15.696 0c0 .55-.826.55-.826 0s.826-.55.826 0zm-14.88 3.583c.735 1.27-1.173 2.372-1.907 1.101-.735-1.272 1.173-2.373 1.907-1.101zm13.602-7.854c.184.318-.292.594-.476.275-.184-.318.293-.593.476-.275zM8.856 19.235c1.113.643.149 2.312-.964 1.67-1.113-.643-.15-2.313.964-1.67z",
    fillRule: "evenodd"
  }))), _symbol84 || (_symbol84 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "question",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8m0 18C6.486 22 2 17.515 2 12 2 6.486 6.486 2 12 2s10 4.486 10 10c0 5.515-4.486 10-10 10zm1.25-5a1.25 1.25 0 10-2.5 0 1.25 1.25 0 002.5 0zM13 15v-1.126A4.01 4.01 0 0016 10c0-2.206-1.794-4-4-4s-4 1.794-4 4h2c0-1.104.897-2 2-2s2 .896 2 2c0 1.103-.897 2-2 2h-1v3h2z",
    fillRule: "evenodd"
  }))), _symbol85 || (_symbol85 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "receipt",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.526 2.15c.526 0 .474.503.474.85v18a1 1 0 01-1.448.895l-3.481-1.74-2.517 1.677a.995.995 0 01-1.109 0l-2.517-1.677-3.481 1.74A1.001 1.001 0 014 21V3c0-.347-.05-.85.475-.85h15.051zM18 19.382V4.619H6v14.763l2.553-1.276a.996.996 0 011.002.062L12 19.798l2.445-1.63a.999.999 0 011.002-.062L18 19.382zM7 8h5v2H7V8zm8 0h2v2h-2V8zm-8 3h4v2H7v-2zm8 0h2v2h-2v-2zm-8 3h6v2H7v-2zm8 0h2v2h-2v-2z"
  }))), _symbol86 || (_symbol86 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "remove",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.415 8.414L15 7l-3.292 3.293L8.415 7 7 8.414l3.293 3.293L7 15l1.415 1.414 3.293-3.292L15 16.414 16.415 15l-3.293-3.293z",
    fillRule: "evenodd"
  }))), _symbol87 || (_symbol87 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "required",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 10.774h-3.075l1.537-2.663L13.538 7 12 9.663 10.462 7 8.538 8.111l1.539 2.663H7v2.223h3.076L8.538 15.66l1.924 1.11 1.539-2.664 1.537 2.664 1.924-1.112-1.537-2.662H17z",
    fillRule: "evenodd"
  }))), _symbol88 || (_symbol88 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "resizer",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 12v8h-8z",
    fillRule: "evenodd"
  }))), _symbol89 || (_symbol89 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "save",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 21c1.103 0 2-.897 2-2V9.414A2.01 2.01 0 0020.414 8L16 3.586A1.986 1.986 0 0014.586 3H5c-1.103 0-2 .896-2 2v14c0 1.103.897 2 2 2h14zM5 19V5h9.586L19 9.414 19.001 19H5zm7-1c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm-1-3c0-.551.449-1 1-1 .551 0 1 .449 1 1 0 .551-.449 1-1 1-.551 0-1-.449-1-1zm2-8h2v3h-2V7zm-2 0H7v3h4V7z"
  }))), _symbol90 || (_symbol90 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "search",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.707 20.293L16.314 14.9A7.928 7.928 0 0018 10a7.945 7.945 0 00-2.344-5.656A7.94 7.94 0 0010 2a7.94 7.94 0 00-5.656 2.344A7.945 7.945 0 002 10c0 2.137.833 4.146 2.344 5.656A7.94 7.94 0 0010 18a7.922 7.922 0 004.9-1.686l5.393 5.392 1.414-1.413zM10 16a5.959 5.959 0 01-4.242-1.757A5.958 5.958 0 014 10c0-1.602.624-3.109 1.758-4.242A5.956 5.956 0 0110 4c1.603 0 3.109.624 4.242 1.758A5.957 5.957 0 0116 10c0 1.603-.624 3.11-1.758 4.243A5.959 5.959 0 0110 16z",
    fillRule: "evenodd"
  }))), _symbol91 || (_symbol91 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "send",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.452 11.45c-4.701-2.04-8.123-3.566-10.63-4.685C5.936 4.586 4.62 4 3.706 4c-.786 0-1.172.476-1.3.632a1.825 1.825 0 00-.147 2.082l3.342 5.57-3.34 5.568a1.822 1.822 0 00.146 2.082c.128.157.514.633 1.3.633.915 0 2.224-.584 7.09-2.754 2.51-1.12 5.938-2.65 10.657-4.696a.912.912 0 00-.001-1.668zM3.892 5.841c.728.149 2.663 1.013 6.19 2.585 1.736.775 3.92 1.748 6.652 2.947h-9.56l-3.28-5.531zm6.163 10.31c-3.583 1.599-5.517 2.46-6.206 2.582l3.326-5.543h9.56a1262.41 1262.41 0 00-6.68 2.96z",
    fillRule: "evenodd"
  }))), _symbol92 || (_symbol92 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "settings",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.726 14a7.977 7.977 0 01-1.111 2.493l1.517 1.518-2.121 2.121-1.517-1.517c-.75.51-1.592.888-2.494 1.122V22h-4v-2.263a7.99 7.99 0 01-2.493-1.122L5.99 20.132l-2.121-2.121 1.517-1.518A7.935 7.935 0 014.264 14H2v-4h2.264a7.945 7.945 0 011.122-2.493L3.869 5.989 5.99 3.868l1.517 1.518A7.98 7.98 0 0110 4.274V6.35C7.674 7.177 6 9.394 6 12c0 3.309 2.692 6 6 6 2.607 0 4.824-1.673 5.65-4h2.076zM22 7.909h-1.492a3.571 3.571 0 01-.359.877l.942.941-1.363 1.364-.943-.941a3.537 3.537 0 01-.877.358V12h-1.817v-1.492a3.546 3.546 0 01-.876-.358l-.942.941-1.365-1.364.943-.941a3.613 3.613 0 01-.36-.877h-1.49V6.091h1.49c.082-.312.204-.604.36-.877l-.943-.942 1.365-1.363.942.942a3.51 3.51 0 01.876-.359V2h1.817v1.492c.313.081.605.202.877.359l.943-.942 1.363 1.363-.942.942c.156.273.278.565.36.877H22v1.818zM17 9a2 2 0 100-4 2 2 0 000 4z",
    fillRule: "evenodd"
  }))), _symbol93 || (_symbol93 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "share",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 20a2 2 0 110-4 2 2 0 010 4M6 14a2 2 0 110-4 2 2 0 010 4M18 4a2 2 0 11.001 3.999A2 2 0 0118 4m0 10c-1.2 0-2.266.542-2.999 1.382l-5.092-2.546c.058-.27.091-.549.091-.836 0-.287-.033-.566-.091-.836l5.092-2.546A3.971 3.971 0 0018 10c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4c0 .287.033.566.091.836L8.999 9.382A3.971 3.971 0 006 8c-2.206 0-4 1.794-4 4s1.794 4 4 4c1.2 0 2.266-.542 2.999-1.382l5.092 2.546c-.058.27-.091.549-.091.836 0 2.206 1.794 4 4 4s4-1.794 4-4-1.794-4-4-4",
    fillRule: "evenodd"
  }))), _symbol94 || (_symbol94 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "smartphone",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.001 18h8.001v2H8.001v-2zm8.001-10v8H8.001V8h8.001zm-.001-2h-8V4h8v2zm0-4h-8c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h8c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2z",
    fillRule: "evenodd"
  }))), _symbol95 || (_symbol95 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "smiley-happy",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2c5.514 0 10 4.486 10 10 0 5.515-4.486 10-10 10S2 17.515 2 12C2 6.486 6.486 2 12 2zm0 18c4.411 0 8-3.589 8-8s-3.589-8-8-8-8 3.589-8 8 3.589 8 8 8zm0-4c1.27 0 2.436-.583 3.2-1.601l1.6 1.202A5.953 5.953 0 0112 18a5.956 5.956 0 01-4.797-2.395l1.598-1.203A3.972 3.972 0 0012 16zm3.05-4.5c-.965 0-1.75-.785-1.75-1.75S14.085 8 15.05 8s1.75.785 1.75 1.75-.785 1.75-1.75 1.75zM9 11.5c-.965 0-1.75-.785-1.75-1.75S8.035 8 9 8s1.75.785 1.75 1.75S9.965 11.5 9 11.5z",
    fillRule: "evenodd"
  }))), _symbol96 || (_symbol96 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "smiley-sad",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2c5.514 0 10 4.486 10 10 0 5.515-4.486 10-10 10S2 17.515 2 12C2 6.486 6.486 2 12 2zm0 18c4.411 0 8-3.589 8-8s-3.589-8-8-8-8 3.589-8 8 3.589 8 8 8zM7 10V8h4v2H7zm6 0V8h4v2h-4zm-1 3c2.138 0 4.147.832 5.657 2.343l-1.415 1.414A5.955 5.955 0 0012 15a5.97 5.97 0 00-4.189 1.704l-1.396-1.433A7.965 7.965 0 0112 13z",
    fillRule: "evenodd"
  }))), _symbol97 || (_symbol97 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "sort",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.498 11L12 7.772 8.502 11 7 9.614 12 5l5 4.614L15.498 11zm0 3L17 15.386 12 20l-5-4.614L8.502 14 12 17.228 15.498 14z"
  }))), _symbol98 || (_symbol98 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "sort-asc",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 5V3h-4v2h4zm2 4V7h-6v2h6zm2 4v-2h-8v2h8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16.707l4.707 4.707 4.707-4.707L12 15.293l-2.293 2.293V2h-2v15.586l-2.293-2.293L4 16.707z"
  }))), _symbol99 || (_symbol99 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "sort-desc",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 13v-2h-4v2h4zm2 4v-2h-6v2h6zm2 4v-2h-8v2h8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.414 7.293L8.707 2.586 4 7.293l1.414 1.414 2.293-2.293V22h2V6.414L12 8.707l1.414-1.414z"
  }))), _symbol100 || (_symbol100 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "sort-unset",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 18.586V13h-2v5.586l-1.293-1.293-1.414 1.414L12 22.414l3.707-3.707-1.414-1.414L13 18.586zM11 5.414V11h2V5.414l1.293 1.293 1.414-1.414L12 1.586 8.293 5.293l1.414 1.414L11 5.414z"
  }))), _symbol101 || (_symbol101 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "star",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 21.955a1 1 0 01-.555-.168L12 18.157l-5.445 3.63a1 1 0 01-1.516-1.106l1.838-6.435-4.584-4.584A1.001 1.001 0 013 7.955h5.382l2.724-5.447c.339-.677 1.45-.677 1.789 0l2.724 5.447h5.38a1 1 0 01.708 1.707l-4.584 4.584 1.838 6.435A1 1 0 0118 21.955zm-6-6c.193 0 .387.057.555.168l3.736 2.49-1.252-4.383a.996.996 0 01.254-.982l3.293-3.293H15a1 1 0 01-.895-.553L12 5.19 9.895 9.4A1 1 0 019 9.954H5.414l3.293 3.293a1 1 0 01.254.982l-1.252 4.384 3.736-2.491c.168-.111.362-.168.555-.168z",
    fillRule: "evenodd"
  }))), _symbol102 || (_symbol102 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "star-filled",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 21.955a1 1 0 01-.555-.168L12 18.157l-5.445 3.63a1 1 0 01-1.516-1.106l1.838-6.435-4.584-4.584A1.001 1.001 0 013 7.955h5.382l2.724-5.447c.339-.677 1.45-.677 1.789 0l2.724 5.447h5.38a1 1 0 01.708 1.707l-4.584 4.584 1.838 6.435A1 1 0 0118 21.955z",
    fillRule: "evenodd"
  }))), _symbol103 || (_symbol103 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "success",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.926 18.652L4 13.725l1.767-1.768 3.074 3.074L17.959 5l1.849 1.682z",
    fillRule: "evenodd"
  }))), _symbol104 || (_symbol104 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "tag",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 9.586l10 10L19.586 14l-10-10H4v5.586zM14 22a.997.997 0 01-.707-.293l-11-11A.997.997 0 012 10V3a1 1 0 011-1h7c.265 0 .52.106.707.293l11 11a.999.999 0 010 1.414l-7 7A.997.997 0 0114 22zM9 7a2 2 0 10-4 0 2 2 0 004 0z",
    fillRule: "evenodd"
  }))), _symbol105 || (_symbol105 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "tasks",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 20.696c-1.103 0-2-.898-2-2v-12c0-1.102.897-2 2-2h10v2H5v12h13v-5h2v5c0 1.102-.897 2-2 2H5zm7.043-4.19L7.116 11.58l1.768-1.768 3.073 3.073L20.062 4l1.85 1.681-9.869 10.825z",
    fillRule: "evenodd"
  }))), _symbol106 || (_symbol106 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "toolbox",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 6.999h-3v-2c0-1.102-.897-2-2-2H9c-1.103 0-2 .898-2 2v2H4c-1.654 0-3 1.346-3 3v4h1v5c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-5h1v-4c0-1.654-1.346-3-3-3zm-11-2h6v2H9v-2zm11 14a1 1 0 01-1 1H5a1 1 0 01-1-1v-5h4c0 1.103.897 2 2 2h4c1.103 0 2-.897 2-2h4v5zm-10-5v-2h4l-.003 2H10zm11-2h-5c0-1.102-.897-2-2-2h-4c-1.103 0-2 .898-2 2H3v-2c0-.551.449-1 1-1h16c.551 0 1 .449 1 1v2z"
  }))), _symbol107 || (_symbol107 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "twitter",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 5.917c-.75.333-1.5.583-2.333.666.833-.5 1.5-1.333 1.833-2.25-.833.5-1.667.834-2.583 1a4.034 4.034 0 00-3-1.333 4.09 4.09 0 00-4.084 4.083c0 .334 0 .667.084.917-3.5-.167-6.5-1.833-8.5-4.333C3 5.333 2.833 6 2.833 6.75c0 1.417.75 2.667 1.834 3.417-.667 0-1.334-.167-1.834-.5v.083c0 2 1.417 3.667 3.25 4-.333.083-.666.167-1.083.167-.25 0-.5 0-.75-.084.5 1.667 2 2.834 3.833 2.834-1.416 1.083-3.166 1.75-5.083 1.75-.333 0-.667 0-1-.084 1.833 1.167 4 1.834 6.25 1.834 7.583 0 11.667-6.25 11.667-11.667V8c.833-.583 1.5-1.333 2.083-2.083z",
    fillRule: "evenodd"
  }))), _symbol108 || (_symbol108 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "user",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.159 18h11.683c-.599-1.808-2.834-3-5.842-3-3.008 0-5.243 1.192-5.841 3zM20 20H4v-1c0-3.533 3.29-6 8-6 4.711 0 8 2.467 8 6v1zm-8-8c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4zm0-6c-1.103 0-2 .896-2 2 0 1.102.897 2 2 2s2-.898 2-2c0-1.104-.897-2-2-2z",
    fillRule: "evenodd"
  }))), _symbol109 || (_symbol109 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "user-group",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.372 19.059c1.478.534 2.629 1.561 2.629 2.941h-2c0-.597-1.413-1.357-3-1.357s-3 .759-3 1.357h-2c0-1.379 1.151-2.407 2.629-2.941a3.483 3.483 0 01-1.129-2.559c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5a3.483 3.483 0 01-1.129 2.559zM18.001 15c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5zm-9.629 4.059c1.478.534 2.629 1.561 2.629 2.941h-2c0-.597-1.413-1.357-3-1.357s-3 .759-3 1.357h-2c0-1.38 1.151-2.407 2.629-2.941A3.483 3.483 0 012.501 16.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5a3.483 3.483 0 01-1.129 2.559zM6.001 15c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5zm9-4c0-.598-1.413-1.357-3-1.357s-3 .759-3 1.357h-2c0-1.38 1.151-2.407 2.629-2.941A3.483 3.483 0 018.501 5.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5a3.483 3.483 0 01-1.129 2.559c1.478.534 2.629 1.561 2.629 2.941h-2zm-3-7c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5z"
  }))), _symbol110 || (_symbol110 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "warning",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 4c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8m0 18C6.486 22 2 17.515 2 12 2 6.486 6.486 2 12 2s10 4.486 10 10c0 5.515-4.486 10-10 10zm1.25-6a1.25 1.25 0 10-2.5 0 1.25 1.25 0 002.5 0zM13 13V6h-2v7h2z",
    id: "efa"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#efa",
    fillRule: "evenodd"
  }))), _symbol111 || (_symbol111 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "youtube",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.833 8S21.667 6.583 21 6c-.75-.833-1.583-.833-2-.833C16.167 5 12 5 12 5s-4.167 0-7 .167C4.583 5.25 3.75 5.25 3 6c-.583.583-.833 2-.833 2S2 9.583 2 11.25v1.5c0 1.583.167 3.25.167 3.25s.166 1.417.833 2c.75.833 1.75.75 2.167.833C6.75 19 12 19 12 19s4.167 0 7-.25c.417-.083 1.25-.083 2-.833.583-.584.833-2 .833-2s.167-1.584.167-3.25v-1.5C22 9.583 21.833 8 21.833 8zM9.917 14.583V9l5.416 2.833-5.416 2.75z",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpritesymbol);
export default __webpack_public_path__ + "static/media/sprite.symbol.cc9d5c249b1db99824d22e35617554f3.svg";
export { ForwardRef as ReactComponent };